import React, { useState } from 'react';

const UserDashboard = () => {
  const [showInfoBanner, setShowInfoBanner] = useState(() => {
    try {
      return sessionStorage.getItem('hideUserDashboardInfoBanner') !== 'true';
    } catch (e) {
      return true;
    }
  });

  const handleCloseBanner = () => {
    setShowInfoBanner(false);
    try {
      sessionStorage.setItem('hideUserDashboardInfoBanner', 'true');
    } catch (e) {
      // ignore
    }
  };

  return (
    <div className="mx-auto bg-[#F3EDF9] rounded-lg shadow-sm min-h-screen">
      <div className="px-6 pt-6">
        {showInfoBanner && (
          <div className="rounded-lg border px-6 py-4 bg-[#D8FDFF] text-[#753ABF] relative flex items-center justify-between border-[#753ABF]">
            <p>
              Kindly complete the Information form. Only after approval & payment this, page will become active
            </p>
            <button
              className="ml-2 bg-[#FFFFFF] p-1 rounded-full"
              onClick={handleCloseBanner}
            >
          <img src="/Assets/Images/crossIcon.svg" className="h-5 w-5" alt="Close information banner" />
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default UserDashboard;